<template>
  <div>
    <div v-if="!_isMobile()">
      <home-header
        :actIndex="actIndex"
        :imgList="imgList"
        :topStyle="paddingNum"
        :logo="logo"
        :productType="productType"
        ref="bannerRef"
      >
      </home-header>
					<!-- 弹框在这 -->
      <home-product></home-product>
      <home-custom></home-custom>
      <!-- <home-program :tabsObj="MtabsObj"></home-program> -->
      <home-data></home-data>
      <home-partner :partnerInfo="partner" ref="partnerRef"></home-partner>
      <home-advisory></home-advisory>
      <home-footer
        :bottom="bottom"
        :bottomInfo="bottomInfo"
        :bottomNews="bottomNews"
        :productType="productType"
      >
      </home-footer>
    </div>
    <div v-else>
      <home-header-m
        :actIndex="MactIndex"
        :imgList="MimgList"
        :topStyle="MtopStyle"
        :logo="Mlogo"
        :bgStyle="MbgStyle"
        ref="MbannerRef"
      ></home-header-m>
      <div class="call-phone-box">
        <img src="../../static/images/7mouth/callPhone@2x.png" @click="calPhone"/>
      </div>
      <home-product-m></home-product-m>
      <!--<home-about :about="about"></home-about>-->
      <home-custom-m></home-custom-m>
      <!-- <home-program-m></home-program-m> -->
      <home-data-m></home-data-m>
      <home-partner-m
        :partnerInfo="Mpartner"
        ref="MpartnerRef"
      ></home-partner-m>
      <home-footer-m
        :bottom="Mbottom"
        :bottomInfo="MbottomInfo"
      ></home-footer-m>
    </div>
  </div>
</template>

<script>
//pc端组件
import HomeHeader from "@/components/pc/Header";
import HomeCustom from "@/components/pc/HomeCustom";
import HomePartner from "@/components/pc/Partner";
import HomeData from "@/components/pc/HomeData";
import HomeProgram from "@/components/pc/HomeProgram";
import HomeProduct from "@/components/pc/HomeProduct";
import HomeAdvisory from "@/components/pc/HomeAdvisory";
import HomeFooter from "@/components/pc/Footer";
//移动端组件
import HomeHeaderM from "@/components/mobile/Header";
import HomeProductM from "@/components/mobile/HomeProduct";
import HomeProgramM from "@/components/mobile/HomeProgram";
import HomeCustomM from "@/components/mobile/HomeCustom";
import HomeDataM from "@/components/mobile/HomeData";
import HomePartnerM from "@/components/mobile/Partner";
import HomeFooterM from "@/components/mobile/Footer";

export default {
  name: "Home",
  data() {
    return {
      //pc端数据
      topStyle: "padding-bottom: 0",
      actIndex: 0,
      imgList: [],
      about: {},
      bottom: {},
      logo: "",
      bottomInfo: {},
      partner: [],
      business: [],
      advantage: [],
      develop: [],
      productType: [],
      bottomNews: [],

      //移动端数据
      MtopStyle: "",
      MbgStyle: "background-color:black;",
      MactIndex: 0,
      MimgList: [],
      Mabout: {},
      Mbottom: {},
      Mlogo: "",
      MbottomInfo: {},
      Mpartner: [],
      Mbusiness: [],
      Madvantage: [],
      Mdevelop: [],
      showHeader: false,
      MtabsObj:{}
    };
  },
  components: {
    //pc端
    HomeHeader,
    HomeCustom,
    HomeData,
    HomeProgram,
    HomeProduct,
    HomePartner,
    HomeAdvisory,
    HomeFooter,
    //移动端
    HomeHeaderM,
    HomeCustomM,
    HomeProgramM,
    HomeProductM,
    HomeDataM,
    HomePartnerM,
    HomeFooterM,
  },
  beforeCreate() {},
  created() {},
  mounted() {
    this.getTabsObj();
    this.getViewNum();
    this.getBannerList();
    if (!this._isMobile()) {
      this.getPartnerList();
      this.getPageData();
    } else {
      this.getPageDataM();
    }
  },
  computed: {
    paddingNum() {
      // let num = document.body.clientWidth * 0.5625
      let num = 0;
      let styleStr = this.topStyle + num + "px";
      return styleStr;
    },
  },
  methods: {
    calPhone(){ //拨打电话
      window.location.href = "tel:13824289487";
    },
    getTabsObj() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/productandsolve",
        null,
        (res) => {
          if (res.code == 1) {
            // console.log(res.data.solveDown.rightList, "aijiow");
            this.tabsObj = res.data.solveDown;
          }
        }
      );
    },
    // is_wexin(url) {
    //   var ua = navigator.userAgent.toLowerCase();
    //   if (ua.match(/MicroMessenger/i) == "micromessenger") {
    //     //是微信浏览器
    //     var date = new Date().getTime();
    //     const jsApiList = [
    //       "onMenuShareAppMessage",
    //       "onMenuShareTimeline",
    //       "onMenuShareQQ",
    //       "onMenuShareWeibo",
    //     ];
    //     this.$http.post(
    //       "https://eartisanapplets.wsandos.com/api/index/getJssdk",
    //       { url: url },
    //       (res) => {
    //         console.log(res,'aoiwio')
    //         wx.config({
    //           debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //           appId: res.data.appId, // 必填，公众号的唯一标识
    //           timestamp: res.data.timestamp, // 必填，生成签名的时间戳
    //           nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
    //           signature: res.data.signature, // 必填，签名
    //           jsApiList: jsApiList, // 必填，需要使用的JS接口列表
    //         });

    //         wx.ready(function () {
    //           // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
    //           // 注册分享朋友圈事件。
    //           wx.onMenuShareTimeline({
    //             title: "一匠科技！~~~~~~~~~~", // 分享标题
    //             link: window.location.href, // 分享链接，该链接域名必须与当前企业的可信域名一致
    //             imgUrl: "http://it.oss.qorosauto.com/qoros/mina/milestone.jpg", // 分享图标
    //             success: function () {
    //               console.log("success!");
    //             },
    //             cancel: function () {
    //               console.log("cancel!");
    //             },
    //           });

    //           // 注册分享朋友事件
    //           wx.onMenuShareAppMessage({
    //             title: "分享的标题", // 分享标题
    //             desc: "分享的描述",
    //             link: window.location.href, // 分享链接，该链接域名必须与当前企业的可信域名一致
    //             imgUrl: "http://it.oss.qorosauto.com/qoros/mina/milestone.jpg", // 分享图标
    //             success: function () {
    //               console.log("success!");
    //             },
    //             cancel: function () {
    //               console.log("cancel!");
    //             },
    //           });
    //         });
    //       }
    //     );
    //   }
    // },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    getBannerList() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/banner",
        null,
        (res) => {
          if (res.code == 1) {
            this.imgList = res.data;
            this.MimgList = res.data;
          }
        }
      );
    },
    getPartnerList() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/cooperative",
        null,
        (res) => {
          if (res.code == 1) {
            this.partner = res.data;
          }
        }
      );
    },
    getViewNum() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/browsedlist",
        null,
        (res) => {
          if (res.code == 1) {
            // console.log(res.msg);
          }
        }
      );
    },
    getPageData() {
      this.$http.post("home/index/homeinfo", null, (res) => {
        // console.log(res.data)
        this.bottom = res.data.bottom[0];
        this.logo = this.bottom.logo;
        // this.imgList = res.data.banner;

        this.about = res.data.company[0];
        this.bottomInfo = res.data.contact[0];
        // this.partner = res.data.partner;
        this.business = res.data.work;
        this.advantage = res.data.software;
        this.develop = res.data.flow;
        this.productType = res.data.type;
        this.bottomNews = res.data.b_news;
        this.showHeader = true;
      });
    },
    getPageDataM() {
      this.$http.post("home/index/m_homeinfo", null, (res) => {
        this.Mbottom = res.data.bottom[0];
        this.Mlogo = this.Mbottom.logo;
        // this.MimgList = res.data.banner;
        this.Mabout = res.data.company[0];
        this.MbottomInfo = res.data.contact[0];
        this.Mpartner = res.data.partner;
        this.Mbusiness = res.data.work;
        this.Madvantage = res.data.software;
        this.Mdevelop = res.data.flow;
        this.$nextTick(() => {
          this.$refs.MbannerRef.imgSwiper();
          // this.$refs.MpartnerRef.imgSwiper();
          // this.$refs.MbusinessRef.imgSwiper();
          // this.$refs.MdevelopRef.imgSwiper();
        });
      });
    },
  },
};
</script>

<style lang="stylus">
.call-phone-box {
  position: sticky;
  top: 7rem;
  right: 0.1rem;
  width: 100%;
  height: 0.88rem;
  background: none;
  display: flex;
  justify-content: flex-end;
  z-index: 5;

  img {
    background: #FFFFFF;
    width: 0.88rem;
    height: 0.88rem;
    box-shadow: 1px 1px 1px 1px rgba(185, 185, 185, 0.2);
    border-radius: 50%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/pc/Home.vue